import { VpSkeleton } from '@vtmn-play/react'

export function SeasonCardSkeleton() {
  return (
    <li>
      <div className="season-selection-page__season-skeleton" aria-hidden="true">
        <VpSkeleton shape="squared" style={{ width: '80px', height: '18px' }} />
        <VpSkeleton shape="squared" style={{ width: '60px', height: '36px' }} />
        <VpSkeleton shape="squared" style={{ width: '90px', height: '28px', borderRadius: '999px' }} />
      </div>
    </li>
  )
}
